import WindowSizeMixin from '@/mixins/windowSize'

export default {
  mixins: [WindowSizeMixin],
  data () {
    return {
      filtersOffset: { top: 0 },
      showStickyFilters: false,
      observer: null,
      marginTop: 135
    }
  },
  computed: {
    isStickyTopBarActive () {
      return !this.isMobile && this.showStickyFilters
    }
  },
  mounted () {
    setTimeout(this.computeFiltersTop, 500)
    this.addEventListeners()
    this.setMutationObserver()
  },
  beforeDestroy () {
    this.removeEventListeners()
    this.disconnectMutationObserver()
  },
  methods: {
    addEventListeners() {
      window.addEventListener('scroll', this.computeFiltersTop)
    },
    removeEventListeners() {
      window.removeEventListener('scroll', this.computeFiltersTop)
    },
    setMutationObserver () {
      this.observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          const newValue = mutation.target.getAttribute(mutation.attributeName)
          this.$nextTick(() => {
            if (mutation.attributeName === 'data-show-sticky-filters') {
              return this.showStickyFilters = newValue === 'true'
            }
          })
        }
      })

      const productsNode = document.getElementById('products')
      if (!!productsNode) this.observer.observe(productsNode, { attributes: true })
    },
    disconnectMutationObserver () {
      this.observer?.disconnect()
    },
    computeFiltersTop () {
        let header = document.querySelector('.header-wrapper__inner')
        let headerTop = header.getBoundingClientRect().top
        let headerHeight = header.offsetHeight

        this.filtersOffset.top = Math.max(...[headerHeight + headerTop + this.marginTop, this.marginTop])
    }
  }
}
